import { __extends } from "tslib";
import { EditorType_$type } from "./EditorType";
import { IgrColumn } from "./igr-column";
import { NumericColumn } from "./NumericColumn";
import { ensureBool, ensureEnum, arrayFindByName } from "igniteui-react-core";
/**
 * Represents a Numeric grid column, used to allow the developer to display a formatted number in a cell.
*/
var IgrNumericColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrNumericColumn, _super);
    function IgrNumericColumn(props) {
        return _super.call(this, props) || this;
    }
    IgrNumericColumn.prototype.createImplementation = function () {
        return new NumericColumn();
    };
    Object.defineProperty(IgrNumericColumn.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "negativePrefix", {
        /**
         * Gets or sets the string to prefix a negative value. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.ln;
        },
        set: function (v) {
            this.i.ln = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "positivePrefix", {
        /**
         * Gets or sets the string to prefix a positive value. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.lr;
        },
        set: function (v) {
            this.i.lr = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "negativeSuffix", {
        /**
         * Gets or sets the string to suffix a negative value. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.lp;
        },
        set: function (v) {
            this.i.lp = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "positiveSuffix", {
        /**
         * Gets or sets the string to suffix a positive value. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.lt;
        },
        set: function (v) {
            this.i.lt = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "maxFractionDigits", {
        /**
         * Gets or sets the maximum fraction digits. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.k4;
        },
        set: function (v) {
            this.i.k4 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "minFractionDigits", {
        /**
         * Gets or sets the minimum fraction digits. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.k5;
        },
        set: function (v) {
            this.i.k5 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "minIntegerDigits", {
        /**
         * Gets or sets the minimum integer digits. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.k6;
        },
        set: function (v) {
            this.i.k6 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "showGroupingSeparator", {
        /**
         * Gets or sets whether to show a grouping separator. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.kz;
        },
        set: function (v) {
            this.i.kz = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "formatString", {
        /**
         * Gets or sets the format string to apply to the value. If set, the other value formatting properties on this column are ignored.
        */
        get: function () {
            return this.i.li;
        },
        set: function (v) {
            this.i.li = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "formatSpecifiers", {
        get: function () {
            return this.i.kw;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.kw = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "formatOverride", {
        /**
         * Gets or sets the INTL NumericFormat object to use for formatting the date values.
        */
        get: function () {
            return this.i.k9;
        },
        set: function (v) {
            this.i.k9 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "editorType", {
        /**
         * Gets or sets the editor type used for editing cells in this column.
        */
        get: function () {
            return this.i.kx;
        },
        set: function (v) {
            this.i.kx = ensureEnum(EditorType_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "editorDataSource", {
        /**
         * Gets or sets the ComboBox data source.
        */
        get: function () {
            return this.i.k8;
        },
        set: function (v) {
            this.i.k8 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "editorTextField", {
        /**
         * Gets or sets the ComboBox text field.
        */
        get: function () {
            return this.i.lf;
        },
        set: function (v) {
            this.i.lf = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrNumericColumn.prototype, "editorValueField", {
        /**
         * Gets or sets the ComboBox value field.
        */
        get: function () {
            return this.i.kv;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.kv = v;
        },
        enumerable: false,
        configurable: true
    });
    IgrNumericColumn.prototype.findByName = function (name) {
        var baseResult = _super.prototype.findByName.call(this, name);
        if (baseResult) {
            return baseResult;
        }
        if (this.formatSpecifiers != null && arrayFindByName(this.formatSpecifiers, name)) {
            return arrayFindByName(this.formatSpecifiers, name);
        }
        return null;
    };
    return IgrNumericColumn;
}(IgrColumn));
export { IgrNumericColumn };
//# sourceMappingURL=igr-numeric-column.js.map
